/*
 * @Author: YuanYuan
 * @Date: 2024-05-20 18:37:13
 * @LastEditTime: 2025-02-24 14:22:25
 * @Description: 统一正则
 */
export default [
  {
    name: 'NormalDomain',
    value: new RegExp(/^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/) // waap中域名正则
  },
  {
    name: 'StrictDomain',
    value: new RegExp(/^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})*\.[a-zA-Z]{2,}$/)
  },
  {
    name: 'WildDomain',
    value: new RegExp(/^(\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/) // 泛域名正则
  },
  {
    name: 'CertDomain',
    value: new RegExp(/^(\*\.)?([A-Za-z0-9-]+\.)*[A-Za-z0-9-]+(\.[A-Za-z]{2,})$/) // 一键证书申请中域名的校验
  },
  {
    name: 'IP',
    value: new RegExp(/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/) // ip
  },
  {
    name: 'SlashStart',
    value: new RegExp(/^\//) // 开头是斜杠
  },
  {
    name: 'SlashStartEnd',
    value: new RegExp(/^\/.*\/$/) // 开头结尾都是斜杠
  },
  {
    name: 'PositiveInt',
    value: window.ELEMENT.RegexpGenerate('POSITIVE_INTEGER')
  },
  {
    name: 'ValidNum',
    value: new RegExp(/^[-+]?\d+(\.\d+)?$/) // 合法数字，包括浮点数
  },
  {
    name: 'PositiveIntAnd0',
    value: new RegExp(/^\d+$/)
  },
  {
    name: 'Port',
    value: new RegExp(/^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/)
  },
  {
    name: 'Email',
    value: window.ELEMENT.RegexpGenerate('EMAIL')
  },
  {
    name: 'EnCnNum_',
    value: new RegExp(/^[\u4e00-\u9fa5a-zA-Z0-9_]+$/)
  }
]
